import script from "./AddMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMember.vue?vue&type=script&setup=true&lang=js"

import "./AddMember.vue?vue&type=style&index=0&id=293b06d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-293b06d7"]])

export default __exports__